import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;

const Logout = () => {
	const navigate = useNavigate();

	useEffect(() => {
		const performLogout = async () => {
			try {
				// Llamar al endpoint de logout del backend
				const authData = JSON.parse(localStorage.getItem("authUser"));
				if (authData?.accessToken) {
					await axios.post(`${baseURL}auth/logout`, null, {
						headers: {
							Authorization: `Bearer ${authData.accessToken}`,
						},
					});
				}
			} catch (error) {
				// Si falla el logout en el backend, igual limpiamos la sesión local
				console.warn("Error al cerrar sesión en el servidor:", error);
			} finally {
				// Limpiar localStorage
				localStorage.removeItem("authUser");
				localStorage.removeItem("authToken");
				localStorage.removeItem("empresaSeleccionada");

				// Redirigir al login
				navigate("/login");
			}
		};

		performLogout();
	}, [navigate]);

	// Mostrar un mensaje mientras se procesa el logout
	return (
		<div className="d-flex justify-content-center align-items-center min-vh-100">
			<div className="text-center">
				<div className="spinner-border text-primary" role="status">
					<span className="visually-hidden">Cargando...</span>
				</div>
				<p className="mt-3">Cerrando sesión...</p>
			</div>
		</div>
	);
};

export default Logout;
